import { getLayout } from '@components/PageLayouts/Layout/Standard';

/* Components */
import LocationGenericPageContainer from '@scenes/LocationPage/LocationPageGeneric';

/* Constants */
import { PAGE_TYPE_LOCATION } from '@constants/pages';

/* Apis & Queries */
import { reviews } from '@api/apis';
import { getUnitedStatesLocationTemplate } from '@integrations/contentful/queries/location/getUnitedStatesCollection';

/* Hooks */
import { ssrGQLContentfulQuery } from '@integrations/contentful/contentful.hooks';

/* Types */
import { ContentBlock, LocationResponseCountry, MetaData } from '@scenes/LocationPage/locationPage.types';
import { UnitedStatesLocationTemplate } from '@integrations/contentful/contentful.types.genned';
import { getLocationStateCollection } from '@integrations/contentful/queries/location/getLocalStateCollection';

export type UnitedStatesLocationTemplateUnion = UnitedStatesLocationTemplate & {
  contentBlocks: ContentBlock;
  metaData: Partial<MetaData>;
};

function LocationPage(props: any) {
  return <LocationGenericPageContainer {...props} />;
}

LocationPage.pageAttributes = { page: PAGE_TYPE_LOCATION };
LocationPage.Layout = getLayout({ promo: true, footer: true });

export default LocationPage;

/* Gonna use SSG here. Doing a test */
export async function getStaticProps({ preview = false }) {
  /* Get reviews */
  const { data: reviewData } = await reviews.list();
  /* Get Base Us Country */
  const [
    {
      data: { unitedStatesLocationTemplateCollection },
    },
    {
      data: { locationStateCollection },
    },
    statsResponse,
  ] = await Promise.all([
    ssrGQLContentfulQuery<LocationResponseCountry>({
      query: getUnitedStatesLocationTemplate(),
    }),
    ssrGQLContentfulQuery<any>({
      query: getLocationStateCollection(),
    }),
    fetch(`${process.env.NEXT_PUBLIC_API_HOST_FULL_URL}/api/clients/stats`),
  ]);

  const stats = await statsResponse?.json();
  const countryData = (unitedStatesLocationTemplateCollection?.items?.[0] as UnitedStatesLocationTemplateUnion & { stats: any }) || null;
  const geoList = locationStateCollection?.items || null;

  /* normalize some of the data. We do this because country substitutions are different, and how its set up. */
  if (countryData) {
    countryData.stats = stats;
    countryData.metaData = {
      title: countryData.metaTitle,
      description: countryData.metaDescription,
    };

    countryData.contentBlocks = {
      contentOneTitle: countryData.contentOneTitle!,
      contentOneBody: countryData.contentOneBody!,
      contentTwoTitle: countryData.contentTwoTitle!,
      contentTwoBody: countryData.contentTwoBody!,
    };
  }

  return {
    props: {
      locationData: countryData,
      geoList,
      reviews: reviewData.reviews,
      stats: countryData?.stats,
    },
  };
}
